// Baut die Feld-Konfigurationen der Terminplanungs-Sidebar
import {
  minimaltransferszenarioOptions,
  maxWartezeitOptions,
  getBlankSyncState,
  verworfenGrundToLabel,
  areZiellandFlughaefenEqual,
  arraysEqualUnordered,
} from '@/core/common/helpers/utils';
import { CalendarPlus, CircleCheck, CircleHelp, FileText, CircleX } from 'lucide-vue';
import { lucideHtml } from '@/core/common/helpers/lucide-html';

// Liefert die Reisedaten-Felder (daten)
// das Layout wird hierdurch bestimmt: column, full, icon -> Column heißt, dass es in der "zweiten" Spalte stehen soll
export function buildReisedaten(reisetermin) {
  return [
    {
      label: 'Hotelnächte',
      value: reisetermin.metadata?.hotelnaechte,
      valueEdited: reisetermin.metadata?.hotelnaechte,
      valueDiffersSeason: reisetermin.metadata?.hotelnaechte !== reisetermin.gueltigeSaison.hotelnaechte,
      valueSeason: reisetermin.gueltigeSaison.hotelnaechte,
      renderer: null,
      editable: true,
      editType: 'number',
      paramLabel: 'hotelnaechte',
    },
    {
      label: 'Vorverlängerung',
      value: reisetermin.metadata?.vorverlaengerung,
      valueEdited: reisetermin.metadata?.vorverlaengerung,
      valueDiffersSeason:
        reisetermin.metadata?.vorverlaengerung !== reisetermin.gueltigeSaison.vorverlaengerung,
      valueSeason: reisetermin.gueltigeSaison.vorverlaengerung,

      renderer: null,
      editable: true,
      editType: 'number',
      append: null,
      paramLabel: 'vorverlaengerung',
    },
    {
      label: 'Erw. Termindurchführungsquote',
      value: reisetermin.metadata?.erwarteteTermindurchfuehrungsquote,
      valueEdited: reisetermin.metadata?.erwarteteTermindurchfuehrungsquote,
      valueDiffersSeason:
        reisetermin.metadata?.erwarteteTermindurchfuehrungsquote !==
        reisetermin.gueltigeSaison.erwarteteTermindurchfuehrungsquote,
      valueSeason: reisetermin.gueltigeSaison.erwarteteTermindurchfuehrungsquote,

      renderer: null,
      editable: true,
      editType: 'number',
      append: '%',
      paramLabel: 'erwarteteTermindurchfuehrungsquote',
    },
    {
      label: 'Kalk Pax',
      value: reisetermin.metadata?.kalkPax,
      valueEdited: reisetermin.metadata?.kalkPax,
      valueDiffersSeason: reisetermin.metadata?.kalkPax !== reisetermin.gueltigeSaison.kalkPax,
      valueSeason: reisetermin.gueltigeSaison.kalkPax,
      renderer: null,
      editable: true,
      editType: 'number',
      paramLabel: 'kalkPax',
    },
    {
      label: 'Plan Pax',
      value: reisetermin.metadata?.planPax,
      renderer: null,
      editable: false,
    },
    {
      label: 'FC Pax',
      value: reisetermin.metadata?.forecastPax,
      renderer: null,
      editable: false,
    },
    {
      label: 'Durchführbare Min Pax',
      column: 2,
      value: reisetermin.metadata?.durchfuehrbareMinPax,
      valueEdited: reisetermin.metadata?.durchfuehrbareMinPax,
      valueDiffersSeason:
        reisetermin.metadata?.durchfuehrbareMinPax !== reisetermin.gueltigeSaison.durchfuehrbareMinPax,
      valueSeason: reisetermin.gueltigeSaison.durchfuehrbareMinPax,
      renderer: null,
      editable: true,
      editType: 'number',
      paramLabel: 'durchfuehrbareMinPax',
    },

    {
      label: 'Min Pax',
      column: 2,
      value: reisetermin.metadata?.minPax,
      valueEdited: reisetermin.metadata?.minPax,
      valueDiffersSeason: reisetermin.metadata?.minPax !== reisetermin.gueltigeSaison.minPax,
      valueSeason: reisetermin.gueltigeSaison.minPax,
      renderer: null,
      editable: true,
      editType: 'number',
      paramLabel: 'minPax',
    },
    {
      label: 'Max Pax',
      column: 2,
      value: reisetermin.metadata?.maxPax,
      valueEdited: reisetermin.metadata?.maxPax,
      valueDiffersSeason: reisetermin.metadata?.maxPax !== reisetermin.gueltigeSaison.maxPax,
      valueSeason: reisetermin.gueltigeSaison.maxPax,
      renderer: null,
      editable: true,
      editType: 'number',
      paramLabel: 'maxPax',
    },
    {
      label: 'Vornacht möglich',
      column: 2,
      value: reisetermin.metadata?.vornachtMoeglich,
      valueEdited: reisetermin.metadata?.vornachtMoeglich,
      valueDiffersSeason:
        reisetermin.metadata?.vornachtMoeglich !== reisetermin.gueltigeSaison.vornachtMoeglich,
      valueSeason: reisetermin.gueltigeSaison.vornachtMoeglich,
      renderer: null,
      editable: true,
      editType: 'checkbox',
      paramLabel: 'vornachtMoeglich',
    },
    {
      label: 'EK kalk. Vornacht DZ p.P.',
      column: 2,
      value: reisetermin.metadata?.einkaufspreisVornachtDzProPerson,
      valueEdited: reisetermin.metadata?.einkaufspreisVornachtDzProPerson,
      valueDiffersSeason:
        reisetermin.metadata?.einkaufspreisVornachtDzProPerson !==
        reisetermin.gueltigeSaison.einkaufspreisVornachtDzProPerson,
      valueSeason: reisetermin.gueltigeSaison.einkaufspreisVornachtDzProPerson,
      renderer: null,
      editable: true,
      editType: 'number',
      append: '€',
      paramLabel: 'einkaufspreisVornachtDzProPerson',
    },
    {
      label: 'Releasefrist',
      column: 2,
      value: [...reisetermin.metadata?.releasefrist],
      valueEdited: [...reisetermin.metadata?.releasefrist],
      valueDiffersSeason: reisetermin.metadata?.releasefrist.map(
        (releasefrist, i) => releasefrist !== reisetermin.gueltigeSaison?.releasefrist[i]
      ),
      valueSeason: reisetermin.gueltigeSaison?.releasefrist,
      renderer: null,
      editable: Array(reisetermin.metadata?.releasefrist.length).fill(true),
      split: false,
      splitN: true,
      addable: true,
      paramLabel: 'releasefrist',
    },
    {
      label: ['Transferszenario Hin', 'Rück'],
      full: true,
      value: [reisetermin.metadata?.transferszenarioHin, reisetermin.metadata?.transferszenarioRueck],
      valueEdited: [reisetermin.metadata?.transferszenarioHin, reisetermin.metadata?.transferszenarioRueck],
      valueDiffersSeason: [
        reisetermin.metadata?.transferszenarioHin !== reisetermin.gueltigeSaison.transferszenarioHin,
        reisetermin.metadata?.transferszenarioRueck !== reisetermin.gueltigeSaison.transferszenarioRueck,
      ],
      valueSeason: [
        reisetermin.gueltigeSaison.transferszenarioHin?.substring(0, 2),
        reisetermin.gueltigeSaison.transferszenarioRueck?.substring(0, 2),
      ],
      renderer: null,
      editable: [true, true],
      editType: ['select', 'select'],
      options: minimaltransferszenarioOptions,
      split: true,
      paramLabel: ['transferszenarioHin', 'transferszenarioRueck'],
    },
    {
      label: ['Max. Wartezeit Hin', 'Rück'],
      full: true,
      value: [reisetermin.metadata.hinflugMaxWartezeit, reisetermin.metadata.rueckflugMaxWartezeit],
      valueEdited: [reisetermin.metadata.hinflugMaxWartezeit, reisetermin.metadata.rueckflugMaxWartezeit],
      valueDiffersSeason: [
        reisetermin.metadata?.hinflugMaxWartezeit !== reisetermin.gueltigeSaison.hinflugMaxWartezeit,
        reisetermin.metadata?.rueckflugMaxWartezeit !== reisetermin.gueltigeSaison.rueckflugMaxWartezeit,
      ],
      valueSeason: [
        reisetermin.gueltigeSaison.hinflugMaxWartezeit,
        reisetermin.gueltigeSaison.rueckflugMaxWartezeit,
      ],
      renderer: null,
      editable: [true, true],
      editType: ['select', 'select'],
      options: maxWartezeitOptions,
      split: true,
      paramLabel: ['hinflugMaxWartezeit', 'rueckflugMaxWartezeit'],
    },
    {
      label: ['Max. Anzahl Transfergruppen Hin', 'Rück'],
      full: true,
      value: [
        reisetermin.metadata.hinflugMaxAnzahlTransfergruppen,
        reisetermin.metadata.rueckflugMaxAnzahlTransfergruppen,
      ],
      valueEdited: [
        reisetermin.metadata.hinflugMaxAnzahlTransfergruppen,
        reisetermin.metadata.rueckflugMaxAnzahlTransfergruppen,
      ],
      valueDiffersSeason: [
        reisetermin.metadata?.hinflugMaxAnzahlTransfergruppen !==
          reisetermin.gueltigeSaison.hinflugMaxAnzahlTransfergruppen,
        reisetermin.metadata?.rueckflugMaxAnzahlTransfergruppen !==
          reisetermin.gueltigeSaison.rueckflugMaxAnzahlTransfergruppen,
      ],
      valueSeason: [
        reisetermin.gueltigeSaison.hinflugMaxAnzahlTransfergruppen,
        reisetermin.gueltigeSaison.rueckflugMaxAnzahlTransfergruppen,
      ],
      renderer: null,
      editable: [true, true],
      editType: ['number', 'number'],
      split: true,
      paramLabel: ['hinflugMaxAnzahlTransfergruppen', 'rueckflugMaxAnzahlTransfergruppen'],
    },
    {
      label: 'Weitere Partner',
      full: true,
      halbeWertespalte: true,
      value: partnerKuerzel(reisetermin.metadata),
      valueEdited: partnerKuerzel(reisetermin.metadata),
      valueDiffersSeason: !arraysEqualUnordered(
        partnerKuerzel(reisetermin.metadata),
        partnerKuerzel(reisetermin.gueltigeSaison)
      ),
      valueSeason: partnerKuerzel(reisetermin.gueltigeSaison).join(', ') || '-',
      renderer: null,
      editable: true,
      editType: 'partner',
      paramLabel: 'weiterePartner',
    },
  ];
}

function partnerKuerzel(metadata) {
  return (metadata?.weiterePartner ?? []).map(p => p.countryManagerKuerzel);
}

// Liefert die Reisetermindaten-Felder
export function buildReisetermindaten(reisetermin) {
  return [
    {
      label: 'Zusatztermin',
      icon: CalendarPlus,
      value: reisetermin.istZusatztermin,
      valueEdited: reisetermin.istZusatztermin,
      renderer: null,
      editable: true,
      editType: 'checkbox',
      paramLabel: 'istZusatztermin',
    },
    {
      label: 'In Klärung',
      column: 2,
      icon: CircleHelp,
      value: reisetermin.istInKlaerung,
      valueEdited: reisetermin.istInKlaerung,
      renderer: null,
      editable: true,
      editType: 'checkbox',
      paramLabel: 'istInKlaerung',
    },
    {
      label: 'In Blank angelegt',
      column: 3,
      icon: FileText,
      value: getBlankSyncState(reisetermin?.reiseterminSyncState),
      valueEdited: getBlankSyncState(reisetermin?.reiseterminSyncState),
      renderer:
        getBlankSyncState(reisetermin?.reiseterminSyncState) === 'Angelegt'
          ? lucideHtml(CircleCheck, { class: 'text-success' })
          : getBlankSyncState(reisetermin?.reiseterminSyncState) === 'Nicht angelegt'
          ? lucideHtml(CircleX, { class: 'text-danger' })
          : '-',
      editable: false,
    },
    {
      label: 'Verworfen Grund',
      full: true,
      value: verworfenGrundToLabel[reisetermin?.verworfenData?.grund] ?? '-',
      valueEdited: verworfenGrundToLabel[reisetermin?.verworfenData?.grund] ?? '-',
      notShow: reisetermin.state !== 'Verworfen',
      renderer: null,
      editable: false,
      paramLabel: 'verworfenGrund',
    },
    {
      label: 'Verworfen Kommentar',
      full: true,
      value: reisetermin?.verworfenData?.kommentar ?? '-',
      valueEdited: reisetermin?.verworfenData?.kommentar ?? '-',
      notShow: reisetermin.state !== 'Verworfen',
      renderer: null,
      editable: false,
      paramLabel: 'verworfenKommentar',
    },
  ];
}

// Liefert die Flugdaten-Felder
export function buildFlugdaten(reisetermin, previousFlugdaten) {
  const activeMetadata = reisetermin.metadata;
  return [
    {
      label: 'SKR Flugangebot',
      value: activeMetadata.skrFlugangebot,
      valueEdited: activeMetadata.skrFlugangebot,
      valueDiffersSeason: activeMetadata?.skrFlugangebot !== reisetermin.gueltigeSaison.skrFlugangebot,
      valueSeason: reisetermin.gueltigeSaison.skrFlugangebot,
      renderer: null,
      editable: true,
      editType: 'number',
      paramLabel: 'skrFlugangebot',
      append: '€',
    },
    {
      label: ['Zielland Zielflughäfen', 'Prio'],
      value: [
        activeMetadata?.ziellandZielflughaefen.map(fh => fh.flughafenIataCode),
        activeMetadata?.ziellandZielflughaefen.find(fh => fh.isPrio)?.flughafenIataCode,
      ],
      valueEdited: [
        activeMetadata?.ziellandZielflughaefen.map(fh => fh.flughafenIataCode),
        activeMetadata?.ziellandZielflughaefen.find(fh => fh.isPrio)?.flughafenIataCode,
      ],
      valueDiffersSeason: [
        !areZiellandFlughaefenEqual(
          activeMetadata?.ziellandZielflughaefen.map(fh => fh.flughafenIataCode),
          reisetermin.gueltigeSaison?.ziellandZielflughaefen.map(fh => fh.flughafenIataCode)
        ),
        activeMetadata?.ziellandZielflughaefen.find(fh => fh.isPrio)?.flughafenIataCode !==
          reisetermin.gueltigeSaison?.ziellandZielflughaefen.find(fh => fh.isPrio)?.flughafenIataCode,
      ],
      valueSeason: [
        reisetermin.gueltigeSaison?.ziellandZielflughaefen.map(fh => fh.flughafenIataCode),
        reisetermin.gueltigeSaison?.ziellandZielflughaefen.find(fh => fh.isPrio)?.flughafenIataCode,
      ],
      renderer: null,
      editable: [true, true],
      editType: ['flughafen', 'select'],
      split: true,
      options: previousFlugdaten?.find(item => item.label === 'Zielland Zielflughäfen / Prio')
        ?.valueEdited[0],
      paramLabel: ['ziellandZielflughaefenIataCodes', 'ziellandZielflughafenPrio'],
    },
    {
      label: ['Zielland Abflughäfen', 'Prio'],
      value: [
        activeMetadata?.ziellandAbflughaefen.map(fh => fh.flughafenIataCode),
        activeMetadata?.ziellandAbflughaefen.find(fh => fh.isPrio)?.flughafenIataCode,
      ],
      valueEdited: [
        activeMetadata?.ziellandAbflughaefen.map(fh => fh.flughafenIataCode),
        activeMetadata?.ziellandAbflughaefen.find(fh => fh.isPrio)?.flughafenIataCode,
      ],
      valueDiffersSeason: [
        !areZiellandFlughaefenEqual(
          activeMetadata?.ziellandAbflughaefen.map(fh => fh.flughafenIataCode),
          reisetermin.gueltigeSaison?.ziellandAbflughaefen.map(fh => fh.flughafenIataCode)
        ),
        activeMetadata?.ziellandAbflughaefen.find(fh => fh.isPrio)?.flughafenIataCode !==
          reisetermin.gueltigeSaison?.ziellandAbflughaefen.find(fh => fh.isPrio)?.flughafenIataCode,
      ],
      valueSeason: [
        reisetermin.gueltigeSaison?.ziellandAbflughaefen.map(fh => fh.flughafenIataCode),
        reisetermin.gueltigeSaison?.ziellandAbflughaefen.find(fh => fh.isPrio)?.flughafenIataCode,
      ],
      renderer: null,
      editable: [true, true],
      editType: ['flughafen', 'select'],
      split: true,
      options: previousFlugdaten?.find(item => item.label === 'Zielland Abflughäfen / Prio')?.valueEdited[0],
      paramLabel: ['ziellandAbflughaefenIataCodes', 'ziellandAbflughafenPrio'],
    },
    {
      label: ['OB', 'IB'],
      value: [activeMetadata?.overnightOutbound, activeMetadata?.overnightInbound],
      valueEdited: [activeMetadata?.overnightOutbound, activeMetadata?.overnightInbound],
      valueDiffersSeason: [
        activeMetadata?.overnightOutbound !== reisetermin.gueltigeSaison?.overnightOutbound,
        activeMetadata?.overnightInbound !== reisetermin.gueltigeSaison?.overnightInbound,
      ],
      valueSeason: [
        reisetermin.gueltigeSaison?.overnightOutbound,
        reisetermin.gueltigeSaison?.overnightInbound,
      ],
      renderer: null,
      editable: [true, true],
      editType: ['select', 'select'],
      split: true,
      options: [
        { text: '0', value: 0 },
        { text: '+1', value: 1 },
        { text: '+2', value: 2 },
      ],
      paramLabel: ['overnightOutbound', 'overnightInbound'],
    },
    {
      label: 'Hotelstart vor Landung',
      value: activeMetadata?.hotelstartVorLandung,
      valueEdited: activeMetadata?.hotelstartVorLandung,
      valueDiffersSeason:
        !!activeMetadata?.hotelstartVorLandung !== !!reisetermin.gueltigeSaison.hotelstartVorLandung,
      valueSeason: !!reisetermin.gueltigeSaison.hotelstartVorLandung,
      renderer: null,
      editable: true,
      editType: 'checkbox',
      paramLabel: 'hotelstartVorLandung',
    },
    {
      label: 'Rückflug nach Hotelende',
      value: activeMetadata?.rueckflugNachHotelende,
      valueEdited: activeMetadata?.rueckflugNachHotelende,
      valueDiffersSeason:
        !!activeMetadata?.rueckflugNachHotelende !== !!reisetermin.gueltigeSaison.rueckflugNachHotelende,
      valueSeason: !!reisetermin.gueltigeSaison.rueckflugNachHotelende,
      renderer: null,
      editable: true,
      editType: 'checkbox',
      paramLabel: 'rueckflugNachHotelende',
    },
    {
      label: ['Verkehrstag Hin', 'Rück'],
      value: [reisetermin?.verkehrstagHin, reisetermin?.verkehrstagRueck],
      valueEdited: [reisetermin?.verkehrstagHin, reisetermin?.verkehrstagRueck],
      renderer: null,
      editable: [false, false],
      split: true,
      paramLabel: ['verkehrstagHin', 'verkehrstagRück'],
    },
    {
      label: ['Hin: Früheste', 'Späteste Ankunft'],
      column: 2,
      value: [activeMetadata?.fruehesteAnkunft, activeMetadata?.spaetesteAnkunft],
      valueEdited: [activeMetadata?.fruehesteAnkunft, activeMetadata?.spaetesteAnkunft],
      valueDiffersSeason: [
        activeMetadata?.fruehesteAnkunft?.substring(0, 5) !==
          reisetermin?.gueltigeSaison?.fruehesteAnkunft?.substring(0, 5),
        activeMetadata?.spaetesteAnkunft?.substring(0, 5) !==
          reisetermin?.gueltigeSaison?.spaetesteAnkunft?.substring(0, 5),
      ],
      valueSeason: [
        reisetermin?.gueltigeSaison?.fruehesteAnkunft?.substring(0, 5),
        reisetermin?.gueltigeSaison?.spaetesteAnkunft?.substring(0, 5),
      ],
      renderer: null,
      editable: [true, true],
      editType: ['time', 'time'],
      split: true,
      paramLabel: ['fruehesteAnkunft', 'spaetesteAnkunft'],
    },
    {
      label: 'Restriktionen Hin Rollover',
      column: 2,
      value: activeMetadata?.restriktionenHinRollover,
      valueEdited: activeMetadata?.restriktionenHinRollover,
      valueDiffersSeason:
        Boolean(activeMetadata?.restriktionenHinRollover) !==
        Boolean(reisetermin.gueltigeSaison?.restriktionenHinRollover),
      valueSeason: reisetermin?.gueltigeSaison?.restriktionenHinRollover,
      renderer: null,
      editable: false,
      editType: 'checkbox',
      split: false,
      append: '+1',
      paramLabel: 'restriktionenHinRollover',
    },
    {
      label: ['Rück: Frühester', 'Spätester Abflug'],
      column: 2,
      value: [activeMetadata?.fruehesterAbflug, activeMetadata?.spaetesterAbflug],
      valueEdited: [activeMetadata?.fruehesterAbflug, activeMetadata?.spaetesterAbflug],
      valueDiffersSeason: [
        activeMetadata?.fruehesterAbflug?.substring(0, 5) !==
          reisetermin?.gueltigeSaison?.fruehesterAbflug?.substring(0, 5),
        activeMetadata?.spaetesterAbflug?.substring(0, 5) !==
          reisetermin?.gueltigeSaison?.spaetesterAbflug?.substring(0, 5),
      ],
      valueSeason: [
        reisetermin?.gueltigeSaison?.fruehesterAbflug?.substring(0, 5),
        reisetermin?.gueltigeSaison?.spaetesterAbflug?.substring(0, 5),
      ],
      renderer: null,
      editable: [true, true],
      editType: ['time', 'time'],
      split: true,
      paramLabel: ['fruehesterAbflug', 'spaetesterAbflug'],
    },
    {
      label: 'Restriktionen Rück Rollover',
      column: 2,
      value: activeMetadata?.restriktionenRueckRollover,
      valueEdited: activeMetadata?.restriktionenRueckRollover,
      valueDiffersSeason:
        Boolean(activeMetadata?.restriktionenRueckRollover) !==
        Boolean(reisetermin.gueltigeSaison?.restriktionenRueckRollover),
      valueSeason: reisetermin?.gueltigeSaison?.restriktionenRueckRollover,
      renderer: null,
      editable: false,
      editType: 'checkbox',
      split: false,
      append: '+1',

      paramLabel: 'restriktionenRueckRollover',
    },
    {
      label: ['TH Langstrecke', 'TH Inlandsflug'],
      column: 2,
      value: [reisetermin.thLangstrecke, reisetermin.thInlandsflug],
      valueEdited: [reisetermin.thLangstrecke, reisetermin.thInlandsflug],
      renderer: null,
      editable: [true, true],
      editType: ['number', 'number'],
      split: true,
      paramLabel: ['thLangstrecke', 'thInlandsflug'],
      append: ['€', '€'],
    },
    {
      label: ['TH Max Langstrecke', 'TH Max Inlandsflug'],
      column: 2,
      value: [
        reisetermin?.gueltigerSaisonpreis?.thMaxLangstrecke ?? '-',
        reisetermin?.gueltigerSaisonpreis?.thMaxInlandsflug ?? '-',
      ],
      renderer: null,
      editable: [false, false],
      editType: ['number', 'number'],
      split: true,
      append: ['€', '€'],
    },
    {
      label: 'VK Max',
      column: 2,
      value: reisetermin?.gueltigerSaisonpreis?.vkMax ?? '-',
      renderer: null,
      editable: false,
      editType: 'number',
      append: '€',
    },
  ];
}
